import { render, staticRenderFns } from "./GameParty.vue?vue&type=template&id=480b3702&scoped=true&"
import script from "./GameParty.vue?vue&type=script&lang=js&"
export * from "./GameParty.vue?vue&type=script&lang=js&"
import style0 from "./GameParty.vue?vue&type=style&index=0&id=480b3702&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480b3702",
  null
  
)

export default component.exports